import { RESUME_RECORD_STATUS, RESUME_SOURCE_OPTIONS } from "./statuses";

export const DEFAULT_RESUME_FILTERS = {
  q: "",
  skills: [],
  tags: [],
  experienceMin: "",
  experienceMax: "",
  location: "",
  source: "",
  status: RESUME_RECORD_STATUS.ACTIVE,
  page: 1,
  limit: 20,
};

export const PAGE_SIZE_OPTIONS = [10, 20, 50, 100];

export const SOURCE_FILTER_OPTIONS = [
  { label: "All Sources", value: "" },
  ...RESUME_SOURCE_OPTIONS,
];

export const STATUS_FILTER_OPTIONS = [
  { label: "All Status", value: "" },
  { label: "Active", value: "active" },
  { label: "Archived", value: "archived" },
  { label: "Deleted", value: "deleted" },
];
